import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrentUserService } from '../../../security/current-user.service';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { FormFieldCascadingDropdownConstraint } from '../../../shared/models/form-builder/field-constraints/field-cascading-dropdown-constraint.model';

import { HttpRequest, HttpHeaders } from '@angular/common/http';


export class ConstraintFromMdsDialogModel {
    constructor() { }
    public fieldId: number;
    public constraintId: number;
    public name: string;
}

@Component({
    selector: 'app-constraint-from-mds-dialog',
    standalone: false,
    templateUrl: './constraint-from-mds-dialog.component.html',
    styleUrl: './constraint-from-mds-dialog.component.scss'
})
export class ConstraintFromMdsDialog implements OnInit {
    // Properties.
    public mdsLink: string = "https://mds.max.gov/get_spreadsheet?xls_filename=PARK_CONST_PARK.XLSX&folder=PARK";
    public serviceAccountName: string = "S_CVNXT";
    public onSuccessNotify: string = "";
    public onFailureNotify: string = this.currentUserService.user.emailAddress;
    private status: string = '';

    // Constructor.
    public constructor(
        public dialogRef: MatDialogRef<ConstraintFromMdsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ConstraintFromMdsDialogModel,
        private currentUserService: CurrentUserService,
        private currentSiteService: CurrentSiteService,
        private http: HttpClient) {
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    public Submit() {

    }

    public LoadOnce(): Promise<any> {
        this.status = 'Loading...';

        let baseUrl: string = environment.apiUrl;
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        let url = `${baseUrl}api/FieldConstraint/UpdateConstraintFromMDS/${this.data.fieldId}`;
        //url = `${baseUrl}/${this.endpoint}/createFolderPermissionExpression/${folderId}`;

        let constraintVM: FormFieldCascadingDropdownConstraint = new FormFieldCascadingDropdownConstraint(this.currentSiteService.Site.id);
        constraintVM.mdsLink = this.mdsLink;
        constraintVM.constraintId = this.data.fieldId;
        constraintVM.name = this.data.name;

        return this.http.post<string>(url, constraintVM)
            .toPromise()
            .then(response => {
                this.status = 'Complete'
                return response;
            });
    }

    public Close() {

    }

    public get Status() {
        return this.status;
    }
}
